import { createNamespacedHelpers } from 'vuex'
import { LETTER } from '../interface/letter'
import { merge } from 'lodash'

const initState = {
  guarantee: {},
  isCqsw: false,
  isHlj: false,
  isBsgzw: false,
  applyType: '',
}

const mutations = {
  [LETTER.GUARANTEE](state, paylod) {
    state.guarantee = merge(state.guarantee, paylod)
    console.log(state.guarantee)
  },
  [LETTER.CLEAR](state) {
    state.guarantee = {}
    console.log('clean',state.guarantee )
  },
  [LETTER.CLEAR_API](state) {
    if (state.guarantee && typeof state.guarantee === 'object') {
      if ('apiId' in state.guarantee) {
        delete state.guarantee.apiId;
      }
      if ('apiName' in state.guarantee) {
        delete state.guarantee.apiName;
      }
    }
  },
  setIsCqsw(state,data) {
    state.isCqsw = data
  },
  setIsHlj(state,data) {
    state.isHlj = data
  },
  setIsBsgzw(state,data) {
    state.isBsgzw = data
  },
  setApplyType(state,data) {
    state.applyType = data
  }
}

const { mapMutations, mapState } = createNamespacedHelpers('letter')

export { mapMutations, mapState, LETTER }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
